import LocationList from './LocationList'
export {LocationList}
export default LocationList
